import { useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';
import React from 'react';
import { TPAComponentsProvider } from 'wix-ui-tpa';
import {
  DatePicker as MonthlyDatePickerComponent,
  DatePickerProps as MonthlyDatePickerComponentProps,
} from 'wix-ui-tpa/date-picker';
import { getLocalDateTimeStartOfDay } from '../../../../../../utils/dateAndTime/dateAndTime';
import { useCalendarActions } from '../../../../Hooks/useCalendarActions';
import { DatePickerDataHooks, DatePickerProps } from '../constants';
import { classes as datePickerClasses } from '../DatePicker.st.css';
import { useDatePicker } from '../useDatePicker';
import { classes, st } from './MonthlyDatePicker.st.css';

const MonthlyDatePicker: React.FC<DatePickerProps> = ({ viewModel }) => {
  const {
    onDateChange,
    dateIndications,
    selectedDate,
    today,
    accessibility: { nextAriaLabel, prevAriaLabel },
    firstDayOfTheWeek,
    locale,
  } = useDatePicker(viewModel);

  const { onMonthSelected } = useCalendarActions();
  const { isMobile, isRTL } = useEnvironment();
  const { t } = useTranslation();

  const onMonthChange = async (date: Date) => {
    const localDateTimeStartOfDay = getLocalDateTimeStartOfDay(date);
    await onMonthSelected(localDateTimeStartOfDay);
  };

  return (
    <TPAComponentsProvider value={{ mobile: isMobile, rtl: isRTL }}>
      <MonthlyDatePickerComponent
        data-hook={DatePickerDataHooks.MONTHLY_DATE_PICKER}
        className={st(classes.root, { isMobile }, datePickerClasses.root)}
        value={selectedDate}
        today={today}
        onChange={onDateChange}
        onMonthChange={onMonthChange}
        dateIndication={dateIndications}
        firstDayOfWeek={firstDayOfTheWeek}
        rightArrowAriaLabel={nextAriaLabel}
        leftArrowAriaLabel={prevAriaLabel}
        removeOuterPadding
        excludePastDates
        locale={locale as MonthlyDatePickerComponentProps['locale']}
        fixedWeeks={true}
        showOutsideDays={false}
      />
    </TPAComponentsProvider>
  );
};

export default MonthlyDatePicker;
